import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
// import { Company as Intervention } from 'src/app/shared/models/company/company.model';
import { AuthService } from 'src/app/modules/auth/auth.service';
import { InterventionsService } from 'src/app/modules/interventions/interventions.service';
import { PropertiesService } from 'src/app/modules/properties/properties.service';
import { Intervention } from 'src/app/shared/models/intervention/intervention.model';
import { ApiService } from 'src/app/shared/services/api.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import { ThemeService } from 'src/app/shared/services/theme.service';
var AddInterventionComponent = /** @class */ (function () {
    // END - Add intervention form
    /**
     * Class constructor
     */
    function AddInterventionComponent(authService, helperService, configService, themeService, cookieService, translateService, interventionsService, router, toastrService, propertiesService, apiService) {
        this.authService = authService;
        this.helperService = helperService;
        this.configService = configService;
        this.themeService = themeService;
        this.cookieService = cookieService;
        this.translateService = translateService;
        this.interventionsService = interventionsService;
        this.router = router;
        this.toastrService = toastrService;
        this.propertiesService = propertiesService;
        this.apiService = apiService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.availableStatus = [];
        // BEGIN - Add intervention form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.create'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'primary',
            spinnerColor: 'primary',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-save',
                inline: true,
            },
        };
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    AddInterventionComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Set page title
        this.themeService.setPageTitle(this.translateService.instant('interventions.add.pageTitle'));
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return _this.loggedUser = res; }));
        // Get current lang
        this.lang = this.cookieService.get('lang') || this.configService.defaultLang;
        // Init add form
        this.initForm();
        // Get available intervention status from configService
        this.availableStatus = this.configService.availableInterventionStatus;
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    AddInterventionComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    AddInterventionComponent.prototype.initForm = function () {
        // Set model
        this.model = new Intervention();
        // Set fields
        this.fields = tslib_1.__spread(this.fields, [
            {
                fieldGroupClassName: 'row',
                fieldGroup: [
                    {
                        className: 'col-12 col-sm-6',
                        type: 'input',
                        key: 'name',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.name'),
                            placeholder: this.translateService.instant('interventions.fields.name'),
                            required: true,
                            minLength: 2,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12 col-sm-6',
                        type: 'input',
                        key: 'propertyName',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.propertyName'),
                            placeholder: this.translateService.instant('interventions.fields.propertyName'),
                            required: false,
                            minLength: 2,
                            maxLength: 100,
                        },
                    },
                    {
                        className: 'col-12 col-sm-6 col-md-4 col-lg-3',
                        type: 'input',
                        key: 'type',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.type'),
                            placeholder: this.translateService.instant('interventions.fields.type'),
                            required: false,
                        },
                    },
                    {
                        className: 'col-12 col-sm-6 col-md-4 col-lg-3',
                        type: 'datepicker',
                        key: 'meetingResolutionDate',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.meetingResolutionDate'),
                            placeholder: this.translateService.instant('interventions.fields.meetingResolutionDate'),
                        },
                    },
                    {
                        className: 'col-12 col-sm-6 col-md-4 col-lg-3',
                        type: 'input',
                        key: 'totalFee',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.totalFee'),
                            placeholder: this.translateService.instant('interventions.fields.totalFee'),
                            required: false,
                            type: 'number',
                            step: 0.1,
                            min: 0,
                        },
                    },
                    {
                        className: 'col-12 col-sm-6 col-md-4 col-lg-3',
                        type: 'input',
                        key: 'constructionManagement',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.constructionManagement'),
                            placeholder: this.translateService.instant('interventions.fields.constructionManagement'),
                            required: false,
                            minLength: 2,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12 col-sm-6 col-md-4 col-lg-3',
                        type: 'input',
                        key: 'securityCoordinator',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.securityCoordinator'),
                            placeholder: this.translateService.instant('interventions.fields.securityCoordinator'),
                            required: false,
                            minLength: 2,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12 col-sm-6 col-md-4 col-lg-3',
                        type: 'datepicker',
                        key: 'constructionStart',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.constructionStart'),
                            placeholder: this.translateService.instant('interventions.fields.constructionStart'),
                        },
                    },
                    {
                        className: 'col-12 col-sm-6 col-md-4 col-lg-3',
                        type: 'datepicker',
                        key: 'constructionEnd',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.constructionEnd'),
                            placeholder: this.translateService.instant('interventions.fields.constructionEnd'),
                        },
                    },
                    {
                        className: 'col-12 col-sm-6 col-md-4 col-lg-3',
                        type: 'input',
                        key: 'taxDeductionType',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.taxDeductionType'),
                            placeholder: this.translateService.instant('interventions.fields.taxDeductionType'),
                            required: false,
                            minLength: 2,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12',
                        type: 'textarea',
                        key: 'notes',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.notes'),
                            placeholder: this.translateService.instant('interventions.fields.notes'),
                            required: false,
                            minLength: 1,
                            maxLength: 5000,
                            rows: 5,
                        },
                        expressionProperties: {
                            'templateOptions.description': '(model[field.key]||"").length+"/" +field.templateOptions.maxLength',
                        }
                    }
                ],
            },
        ]);
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    AddInterventionComponent.prototype.onFormSubmit = function () {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant('common.errors.form_is_invalid'));
            return;
        }
        // Activate submit button loading status
        this.formBtnOptions.active = true;
        this.subscriptions.push(this.interventionsService.create(this.model)
            .pipe(finalize(function () { return _this.formBtnOptions.active = false; }))
            .subscribe(function (res) {
            if (res.status) {
                _this.toastrService.success(res.message);
                setTimeout(function () {
                    var lang = _this.translateService.currentLang;
                    _this.router.navigate([lang, 'app', 'interventions', 'detail', res.data._id]);
                }, _this.configService.redirectDelayAfterCreation);
                return;
            }
        }, function (err) {
            // Choose one of the following error handling method.
            // 1) First one show a message right under the form fields
            //    (if the form is properly setted)
            // 2) Second one is used to show a mat-error under each field
            //    in the dynamic form (is meant to be used only in dynamicForm)
            // 3) Third one show toastr notifications for each error
            // 4) Fourth one is used to show mat-error under each field
            //    in the ngx-formly form (is mean to be used only with ngx-formly)
            // this.helperService.handleFormError(form, err);
            // this.helperService.handleDynamicFormError(form, err);
            // this.helperService.handleError(err);
            _this.helperService.handleFormlyError(_this.form, err);
        }));
    };
    return AddInterventionComponent;
}());
export { AddInterventionComponent };
